import { BookLocation } from '../dorian-shared/types/bookLocation/bookLocation';
import { Branch } from '../dorian-shared/types/branch/Branch';

function locationForBranch(
  locationId: number | null | undefined,
  catalog: BookLocation[],
): BookLocation | null {
  const found = catalog.find((location) => Number(location.id) === Number(locationId));
  if (found) {
    return found;
  }
  return catalog.find((location) => location.isDefault) ?? null;
}

function locationTitleForBranch(
  locationId: number | null | undefined,
  resolved: BookLocation | null,
): string | null {
  if (!resolved) {
    return null;
  }
  if (locationId != null && Number(resolved.id) === Number(locationId)) {
    return resolved.title;
  }
  return `Default (${resolved.title})`;
}

export function patchBranchLocation(
  branch: Branch,
  catalog: BookLocation[],
): Branch {
  const resolved = locationForBranch(branch.locationId, catalog);
  const locationTitle = locationTitleForBranch(branch.locationId, resolved);
  const nextLocation = resolved ?? undefined;
  if (
    branch.location_title === (locationTitle ?? '')
    && branch.location?.id === nextLocation?.id
    && branch.location?.image?.imageUrl === nextLocation?.image?.imageUrl
    && branch.location?.backgroundId === nextLocation?.backgroundId
    && branch.location?.title === nextLocation?.title
    && branch.location?.video?.videoUrl === nextLocation?.video?.videoUrl
  ) {
    return branch;
  }
  return {
    ...branch,
    location: nextLocation,
    location_title: locationTitle ?? '',
  };
}

export function patchBranchesWithLocations(
  branches: Branch[] | undefined,
  catalog: BookLocation[] | null | undefined,
): Branch[] | undefined {
  if (!branches || !catalog) {
    return branches;
  }
  let changed = false;
  const next = branches.map((branch) => {
    const patched = patchBranchLocation(branch, catalog);
    if (patched !== branch) {
      changed = true;
    }
    return patched;
  });
  return changed ? next : branches;
}
